import { publicClient, privateClient } from './client';
import { Person } from './Person';

const transactionsPerson = (pub: boolean) => new Person(pub ? publicClient : privateClient);
export default transactionsPerson;
